
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/vehicleManage',
    meta: { title: '车辆管理' },
    component: Layout,
    redirect: '/vehicleManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '车辆管理', activeMenu: '/vehicleManage' },
        component: () => import('@/views/vehicleManage/VehicleManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '车辆管理详情', activeMenu: '/vehicleManage' },
        component: () => import('@/views/vehicleManage/VehicleManageDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑车辆', activeMenu: '/vehicleManage' },
        component: () => import('@/views/vehicleManage/VehicleManageAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增车辆', activeMenu: '/vehicleManage' },
        component: () => import('@/views/vehicleManage/VehicleManageAdd.vue')
      }

    ]
  }

]
